var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_334_4151",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_334_4151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.44961 42C4.68294 42 4.11628 41.6667 3.74961 41C3.38294 40.3333 3.38294 39.6667 3.74961 39L22.2496 7C22.6163 6.33333 23.1996 6 23.9996 6C24.7996 6 25.3829 6.33333 25.7496 7L44.2496 39C44.6163 39.6667 44.6163 40.3333 44.2496 41C43.8829 41.6667 43.3163 42 42.5496 42H5.44961ZM23.9996 20C23.4329 20 22.9583 20.1913 22.5756 20.574C22.1916 20.958 21.9996 21.4333 21.9996 22V28C21.9996 28.5667 22.1916 29.0413 22.5756 29.424C22.9583 29.808 23.4329 30 23.9996 30C24.5663 30 25.0416 29.808 25.4256 29.424C25.8083 29.0413 25.9996 28.5667 25.9996 28V22C25.9996 21.4333 25.8083 20.958 25.4256 20.574C25.0416 20.1913 24.5663 20 23.9996 20ZM23.9996 36C24.5663 36 25.0416 35.808 25.4256 35.424C25.8083 35.0413 25.9996 34.5667 25.9996 34C25.9996 33.4333 25.8083 32.9587 25.4256 32.576C25.0416 32.192 24.5663 32 23.9996 32C23.4329 32 22.9583 32.192 22.5756 32.576C22.1916 32.9587 21.9996 33.4333 21.9996 34C21.9996 34.5667 22.1916 35.0413 22.5756 35.424C22.9583 35.808 23.4329 36 23.9996 36ZM8.89961 38H39.0996L23.9996 12L8.89961 38Z",
    fill: "#FB6868"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.62b9fcc3089a850aa4a58172a7627888.svg";
export { ForwardRef as ReactComponent };